import { render, staticRenderFns } from "./ChannelForwardSetting.vue?vue&type=template&id=5c5684ca&scoped=true"
import script from "./ChannelForwardSetting.vue?vue&type=script&lang=js"
export * from "./ChannelForwardSetting.vue?vue&type=script&lang=js"
import style0 from "./ChannelForwardSetting.vue?vue&type=style&index=0&id=5c5684ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5684ca",
  null
  
)

export default component.exports